.fp-dropdown
  input(v-model='opened' type='checkbox' :name='name' :id='name' data-test='dropdown-input')
  label.fp-dropdown--trigger(:for='name' data-test='dropdown-trigger' ref='trigger')
    template(v-if='slots.trigger')
      slot(name='trigger')
    template(v-else)
      i.fp-icon.fp-glyph-dots-vertical
  .fp-dropdown--menu
    slot
